export const DEFAULT_MESSAGE_MARGIN_TOP = '64px';

export default {};
